import { ActionReducer, Action, ActionReducerMap } from '@ngrx/store';
import * as actions from '../actions';

export interface UsersState {
  isLogin: boolean;
  currentUser: string;
  otp: string;
  isLoading: boolean;
  isLoaded: boolean;
  Package: string;
  appliedRegion: string;
  acode: number;
  RegionId: number;
  authority: number;
  AuthorityRegion: any[];
  Message: string;
  isMsp: boolean;
  ProStatus?: number;
}

const initialState: UsersState = {
  isLogin: false,
  currentUser: '',
  otp: '',
  isLoading: false,
  isLoaded: false,
  Package: 'Standard',
  appliedRegion: 'Default',
  acode: NaN,
  RegionId: 1,
  authority: NaN,
  AuthorityRegion: [],
  Message: '',
  isMsp: false,
  ProStatus: NaN
};

export function reducer(state: UsersState = initialState, action: actions.UserActions): UsersState {
  switch (action.type) {
    case actions.LOGIN:
      return { ...state, currentUser: '', isLogin: false, otp: '', isLoading: true, isLoaded: false};
    case actions.LOGOUT:
      return { ...state, isLogin: true, isLoading: true, isLoaded: false};
    case actions.LOGIN_FAIL:
      return { ...state, currentUser: '', isLogin: false, otp: '', isLoading: false, isLoaded: true, Message: action.payload.Message};
    case actions.LOGIN_SUCCESS:
    case actions.GETUSER_SUCCESS:
      // return Object.assign({}, state, { currentUser: action.payload, isLogin: true });
      return { ...state, currentUser: action.payload.username, isLogin: true,
        otp: action.payload.OtpKey, acode: action.payload.acode, RegionId: action.payload.RegionId,
        Package: action.payload.Package, isLoading: false, isLoaded: true, authority: action.payload.authority,
        isMsp: action.payload.IsMsp, ProStatus: action.payload.ProStatus };
    case actions.GET_ADMIN:
       return {...state, authority: action.payload.authority, AuthorityRegion: action.payload.AuthorityRegion || []};
    case actions.LOGOUT_SUCCESS:
      return { ...state, isLogin: false, isLoading: false, isLoaded: true};
    default:
      return state;
  }
}

// for selector
export const getIsLogin = (state: UsersState) => !state.isLoading && state.isLoaded && state.isLogin;
export const getCurrentUser = (state: UsersState) => state;
export const getCurrentAcode = (state: UsersState) => state.acode;
